import { UtbetalningssattQuery_db_SYSUtbetalningssatt_All } from '../_QueryTypes/UtbetalningssattQuery';
import {
  IUpdateValue,
  BusinessDataFormAction,
} from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import {
  getChangedPathsDeep,
  getModelPath,
} from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataFormActionTransformer/BusinessDataFormActionTransformerUtils';
import { equals, append, path, assocPath } from 'ramda';
import { TEDSYSUtbetalningssattBETSATTEnum } from '../../../../../../globalQueryTypes';

export const orgPersValueString = 'OrgPers_Values';

export const getNewLeverantorFormValue = (
  validUtbetalningssattList: UtbetalningssattQuery_db_SYSUtbetalningssatt_All[],
  leverantorOPTyp: string | null,
  value: IUpdateValue
): IUpdateValue => {
  const changedPaths = getChangedPathsDeep(value);

  if (changedPaths) {
    const changedModelPaths = changedPaths.map(getModelPath);

    const changedUtbetalningssattModelPathIndices = changedModelPaths.reduce<
      number[]
    >((indices, changedModelPath, index) => {
      if (equals(changedModelPath, ['LevBetalningssatt', 'Utbetalningssatt'])) {
        return append(index, indices);
      } else {
        return indices;
      }
    }, []);

    if (changedUtbetalningssattModelPathIndices.length > 0) {
      changedUtbetalningssattModelPathIndices.forEach(
        changedUtbetalningssattModelPathIndex => {
          const changedPath =
            changedPaths[changedUtbetalningssattModelPathIndex];
          const newLevBetalningssattId = path(changedPath, value);

          const newUtbetalningsSatt = validUtbetalningssattList.find(
            validUtbetalningssatt =>
              validUtbetalningssatt.id === newLevBetalningssattId
          );

          if (newUtbetalningsSatt) {
            const kontoNrPath = [
              ...changedPath.slice(0, changedPath.length - 2),
              'NUMERISKA_FAKTURANR',
            ];
            if (
              (newUtbetalningsSatt.BETSATT ===
                TEDSYSUtbetalningssattBETSATTEnum.BANKGIRO___BETALNING_TILL_PLUSGIRONUMMER ||
                newUtbetalningsSatt.BETSATT ===
                  TEDSYSUtbetalningssattBETSATTEnum.BANKGIRO_MED_OCR) &&
              leverantorOPTyp !== 'P'
            ) {
              // Change NUMERISKA_FAKTURANR to JA
              value = assocPath(kontoNrPath, 'JA', value);
            } else {
              value = assocPath(kontoNrPath, 'NEJ', value);
            }
          }
        }
      );
    }
  }

  return value;
};

export const leverantorFormStateActionTransformer =
  (
    validUtbetalningssattList: UtbetalningssattQuery_db_SYSUtbetalningssatt_All[],
    leverantorOPTyp: string | null
  ) =>
  (action: Readonly<BusinessDataFormAction>): BusinessDataFormAction => {
    switch (action.type) {
      case 'UPDATE':
        return {
          ...action,
          value: getNewLeverantorFormValue(
            validUtbetalningssattList,
            leverantorOPTyp,
            action.value
          ),
        };
      default:
        return action;
    }
  };
